export default {
  api: 'https://bikewise.org/api/v2/',
  publicUrl: process.env.PUBLIC_URL,
};
